import React, { useState, useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import LastPeriod from './gender-predictor-landing-page/LastPeriod';
import { postDataFetcher } from '../../dataFetcher';
import CONFIG_OBJECT from '../../config/config';
import './gender-predictor-css/gender-predictor-mobile.css';
import './gender-predictor-css/gender-predictor.css';
import GP_Constants from './gender-predictor-constants/GP_Constants';
import HandleError from '../ErrorBoundry/HandleError';
import App_Constants from '../../app-constants/App_Constants';
import { isMobile } from 'react-device-detect';
import configData from '../../temp/config';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

// Global variable for setting data from child Component
let currentMonthCycle = {
    selectedMonth: 'Select Month',
    momAge: 'Select Age'
}

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

// This component is used for Predicting Gender of child
const GenderPredictor = (props) => {
	const [showResultSection, setShowResultSection] = useState(false);
	const [disableBtn, setDisableBtn] = useState(true);
	const [showForm, setShowForm] = useState(true);
	const [showDesc, setShowDesc] = useState(isMobile ? false : true);
	const [parentCompData, setParentCompData] = useState({});
	const [showEditForm, setShowEditForm] = useState(false);
	const [ovulationCalcData, setOvulationCalcData] = useState({
		showCalender: false,
		apiData: {},
		hasError: false,
		showDesc: true,
		showForm: true,
		showDefaultResult: true,
		showWarningSection: false
	});
	const [componentData, setComponentData] = useState({})
	const [predictorData, setPredictorData] = useState({
		showCalender: false,
		apiData: {},
		hasError: false
	})

	const { t } = props;

	// Calling layout service and caching the response
	useEffect(() => {
		let componentData = props.fields
		setComponentData(componentData);

	}, [])

	// Calling this function on click of Predict Button and calling REST Api
	const predictGender = () => {
		let month = Number(currentMonthCycle.selectedMonth);
		let monthArray = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
		let data = {
			month: currentMonthCycle.selectedMonth.key.value,
			age: currentMonthCycle.momAge
		}
		if (isMobile) {
			setShowDesc(false)
			setShowForm(false)
			setShowEditForm(true)
		}
		// Calling REST API Url
		postDataFetcher(`${CONFIG_OBJECT.GP_REST_URL}${App_Constants.SC_API_KEY}`, data)
			.then(res => {
				console.log(res);
				setPredictorData({
					showCalender: true,
					apiData: res.data.Data,
					resultTitle: { __html: res.data.Data.resultDescription },
					resultSubTitle: { __html: res.data.Data.resultSubDescription  }
				})
				setShowResultSection(true)
				if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = true;
			}, err => {
				console.log(err)
				setPredictorData({
					hasError: true
				})
			});
		// if (isMobile) {

		// }
	}

	const sendLastPeriodData = (selectedMonth, momAge, enableBtn) => {
		currentMonthCycle = {
			selectedMonth: selectedMonth,
			momAge: momAge
		}
		console.log(currentMonthCycle)
		if (momAge !== 'Select Age' && selectedMonth.key.value !== 'Select Month') {
			setDisableBtn(false)
			document.getElementById("calculate-period-button-id").disabled = false;
		}
		document.getElementById("calculate-period-button-id").focus()
	}

	const showMainMenu = () => {
		setShowForm(true);
		setShowEditForm(false)
		setTimeout(function () { window.scrollTo(0, 0); }, 0);
		// setDisableBtn(true);
	}

	const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

	const formRef = useRef(null);
	// const sympRef = useRef(null)
	// const executeSympScroll = () => scrollToRef(sympRef)
	const executeScroll = () => {
		// if(document.getElementsByClassName('form-container test').length)
		scrollToRef(formRef)
	}

	const mySubmitHandler = (e) => {
		e.preventDefault()
	}

	// let resultTitleStr = `It's a <b>Girl!</b>`;
	// const resultTitle = { __html: resultTitleStr };

	// if error then redirect to error page
	if (predictorData.hasError) {
		return (
			<HandleError />
		)
	}
	// if data is coming successfully then render component 
	if (componentData.description) {
		const genderColor = {
			color: predictorData.apiData.resultDescription === GP_Constants.GIRL_MSG ? '#ff0080' : '#58CCED'
		}
		return (
			<>
				<div>
					{componentData.description &&
						<section id="main" data-test="component-ovulation">
							<div className="gender-predictor">
								<div className="calculator-body">
									{showDesc &&
										<div className="container">
											<p className="ovulation-intro">
												{componentData.description.value}
											</p>
										</div>}

									<div className="goals-section container-mobile">
										{showEditForm && <div className="recalculate-wrap-period-form">
											<div className="container">
											<div className="fdlp-mobile">
												<span>{componentData.monthLabel.value}</span><span>{currentMonthCycle.selectedMonth.name.value}</span>
											</div>
											<div className="cycle-length-mobile">
												<span>{componentData.ageLabel.value}</span><span>{currentMonthCycle.momAge}</span>
											</div>
											<button onClick={showMainMenu}>
												<img src="https://dev1.v2.wemshowcase.com/-/media/JssReactWeb/data/media/img/Common/red_pencil.ashx?h=15&amp;w=15&amp;hash=CA6D8D1AE479F86ACEBAF8CBC007C43D" />
												<span>Edit</span>
											</button>
											</div>
										</div>}
									</div>
									<div className={"form-container test"} ref={formRef}>
										{showForm && <form role="form" className="form-inline" onSubmit={mySubmitHandler}>
											<div className="toolform container">
												{<>
													<LastPeriod sendLastPeriodData={sendLastPeriodData} componentData={componentData} currentMonthCycle={currentMonthCycle} />
													<div className="submitBtnWrapper">
														<div className="ovulBtnWrapper">
															<button type="submit" id="calculate-period-button-id" className="btn red calculate-button" onClick={predictGender} disabled={disableBtn}>
																{t('GenderPredictor_SubmitButton')}
															</button>
														</div>
													</div>
												</>}
											</div>

										</form>}
										{!isMobile &&
											<hr className="form-divider"></hr>
										}
										{showResultSection && <>
											<div className="container">
												<div className="result-section">
													<div className="gender-predictor-social-share-component">
														<div className="email-share-container">
															<p className="share-email-text-msg">Share it with your family and friends!</p>
															<Placeholder name="social-share-result" rendering={props.rendering} itemid={props.itemid} />
														</div>
													</div>
													{predictorData.showCalender &&
														<div className="higlight-dates">
															<span className="first-result-text" dangerouslySetInnerHTML={predictorData.resultTitle} >
															</span>
														</div>
													}

													<div className="calendar">
														<img src={`${configData.sitecoreApiHost}${predictorData.apiData.resultIcon.src}`} />
													</div>
													<div className="gender-result-msg-text-wrapper">
														<p className={predictorData.apiData.resultIcon.alt === 'Girl' ? "gender-result-msg-text-girl" : "gender-result-msg-text-boy"} 
														dangerouslySetInnerHTML={predictorData.resultSubTitle}></p>
													</div>
												</div>
											</div>
										</>}
									</div>

								</div>
								<div class="social-share-container">
									<div className="container">
										<Placeholder name="social-share" rendering={props.rendering} itemid={props.itemid} />
									</div>
								</div>
							</div>


						</section>
					}
				</div>
				<div className="period-calculator-note-section">
					<p>{componentData.disclaimerMessage && componentData.disclaimerMessage.value}</p>
				</div>
			</>
		)
	} else {
		return <></>
	}

}

export default withTranslation()(GenderPredictor);
